import { InteractionHelper } from "./UserInteractionHelper";
import { Sticky } from "./Sticky";

new InteractionHelper().Init();
new Sticky().Init();
